import { useState } from 'react';
import { Button, Row, Col, Form, Table } from 'react-bootstrap';

import { useHttpUtils } from '../../Utilities/useHttpUtils'
import { useBusinessUnits } from '../../Utilities/useBusinessUnits';
import useAlert from '../../Alerts/useAlert';
import DateAsLocaleString from '../../Utilities/DateAsLocaleString';
import AdminTile from './AdminTile';
import DateTimePicker from '../../Components/DateTimePicker';
import { convertDateToJsonFormat } from '../../Utilities/useDateUtils';

const GetQirs = () => {
    const { businessUnits } = useBusinessUnits(false);
    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();
    const [qirs, setQirs] = useState(null);
    const [businessUnit, setBusinessUnit] = useState("");
    const [lotNumber, setLotNumber] = useState();
    const [error, setError] = useState();
    const [variant, setVariant] = useState();

    const [dateFilter, setDateFilter] = useState({
        from: null,
        to: null
    });

    const updateDateFilter = (to, from) => {
        if (to) {
            setDateFilter({ ...dateFilter, to: convertDateToJsonFormat(to) });
        }
        if (from) {
            setDateFilter({ ...dateFilter, from: convertDateToJsonFormat(from) });
        }
    }

    const getQirs = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!businessUnit) {
            return;
        }

        let params = new URLSearchParams();

        if (lotNumber) {
            params.append("lotNumber", lotNumber);
        }

        if (dateFilter?.from) {
            params.append("dateFrom", dateFilter.from);
        }

        if (dateFilter?.to) {
            params.append("dateTo", dateFilter.to);
        }

        let url = `api/v1/admin/qir/${businessUnit}?` + params.toString();
        await fetchDataAuthenticated(url, "GET")
            .then(response => {
                if (!response.ok) {
                    return response.json().then(error => Promise.reject(error));
                }
                return response.json();
            })
            .then(data => {
                setVariant("");
                setQirs(data);
                setError(null);
            })
            .catch(error => {
                setVariant("danger");
                setAlert("danger", error.title, error.detail);
                setError(error.detail);
                setQirs(null);
            })
    }

    return (
        <AdminTile
            title={"Get QIRS"}
            description={"Make a request to QIRMS to get a QIR"}
            variant={variant}>
            <>
                {qirs &&
                    (qirs.length > 0
                        ? <Table className="mt-1">
                            <thead>
                                <tr>
                                    <th>Incident Date</th>
                                    <th>Status</th>
                                    <th>Go To</th>
                                </tr>
                            </thead>
                            <tbody>
                                {qirs.map(qir =>
                                    <tr key={`qir-${qir.id}`}>
                                        <td><Button variant="link" href={qir.qirUrl} target="_blank" rel="noreferrer">{qir.qirId}</Button></td>
                                        <td>
                                            <DateAsLocaleString date={qir.incidentDate} />
                                        </td>
                                        <td>
                                            {qir.status}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                        : <Row className="ps-2 mt-1">No QIRS found</Row>
                    )
                }

                <Row className="mt-1">
                    <Form id="QIR-Tile-form" onSubmit={getQirs}>
                        <Form.Group>
                            <div>For</div>
                            <Form.Label><strong>Business Unit</strong></Form.Label>
                            <Form.Select type="text" className="config-select" value={businessUnit} onChange={(e) => setBusinessUnit(e.target.value)} required>
                                <option value="" key={0} >Please Select...</option>
                                {businessUnits.map((bu) => <option value={bu.businessUnitId} key={bu.businessUnitId}>{bu.name}</option>)}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mt-1">
                            <div>By</div>
                            <Form.Label><strong>Lot Number</strong></Form.Label>
                            <Form.Control type="text" value={lotNumber} onChange={(e) => setLotNumber(e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mt-1">
                            <div>Or By</div>
                            <Form.Group as={Row} controlId="dateFrom">
                                <Form.Label column xs={4}>Date From:</Form.Label>
                                <Col xs={8}>
                                    <DateTimePicker name="dateFrom" dateTime={dateFilter.from} handleDateSelect={(date) => updateDateFilter(null, date)} dateOnly isClearable required={false} />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="dateTo">
                                <Form.Label column xs={4}>Date To:</Form.Label>
                                <Col xs={8}>
                                    <DateTimePicker name="dateTo" dateTime={dateFilter.to} handleDateSelect={(date) => updateDateFilter(date, null)} dateOnly isClearable required={false} />
                                </Col>
                            </Form.Group>
                        </Form.Group>
                    </Form>
                </Row>
                {error &&
                    <div>
                        {error}
                    </div>}
                <Button type="submit" form="QIR-Tile-form" className="ms-auto mt-auto">Get</Button>
            </>
        </AdminTile>
    )
}

export default GetQirs;